import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAJUTL7nH-fNSCfqxEgpNlucb5Pnrw81yU",
  authDomain: "clipping4u-375bf.firebaseapp.com",
  projectId: "clipping4u-375bf",
  storageBucket: "clipping4u-375bf.appspot.com",
  messagingSenderId: "345201992957",
  appId: "1:345201992957:web:78b50d50ef5ae26f470a94"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;